<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->







(function( $ ){



  $('ul.tabs li').on('click', function(){
    // get the data attribute
    var tab_id = $(this).attr('data-tab');
    // remove the default classes
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');
    // add new classes on mouse click
    $(this).addClass('current');
    $('#'+tab_id).addClass('current');
  });

    $('.cookie-header').click(function(){
    $(this).toggleClass('active').next('.cookie-content').slideToggle(300);
    $('.cookie-header').not($(this)).removeClass('active').next('.cookie-content').slideUp(300);
  });

  $(".halo-sidebar-close").on("click",function(){
    $("body").removeClass("menu_open");
  })
  
})( jQuery );



let marqueeSlider = document.querySelector(".marquee-sliders");
let marqueeSlide = document.querySelector(".b-slider__refs");
let mainTicker = new Flickity(".marquee-sliders", {
  accessibility: true,
  resize: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false,
  percentPosition: true,
  setGallerySize: true
});

// Set initial position to be 0
mainTicker.x = 0;

// Start the marquee animation
play();

// Main function that 'plays' the marquee.
function play() {
  // Set the decrement of position x
  mainTicker.x -= 1.5;

  // Settle position into the slider
  mainTicker.settle(mainTicker.x);

  // Set the requestId to the local variable
  requestId = window.requestAnimationFrame(play);
}

// Main function to cancel the animation.
function pause() {
  if (requestId) {
    // Cancel the animation
    window.cancelAnimationFrame(requestId);

    // Reset the requestId for the next animation.
    requestId = undefined;
  }
}

// Pause on hover/focus
marqueeSlider.addEventListener("mouseenter", () => pause());

// Unpause on mouse out / defocus
marqueeSlider.addEventListener("mouseleave", () => play());


let secondMarqueeSlider = document.querySelector(".marquee-slider");
let secondMarqueeSlide = document.querySelector(".b-slider__ref");
let secondMainTicker = new Flickity(".marquee-slider", {
  accessibility: true,
  resize: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false,
  percentPosition: true,
  setGallerySize: true
});

// Set initial position to be 0
secondMainTicker.x = 0;

// Start the marquee animation
secondPlay();

// Main function that 'plays' the marquee.
function secondPlay() {
  // Set the increment of position x to change direction
  secondMainTicker.x += 1.5;

  // Settle position into the slider
  secondMainTicker.settle(secondMainTicker.x);

  // Set the requestId to the local variable
  secondRequestId = window.requestAnimationFrame(secondPlay);
}

// Main function to cancel the animation.
function secondPause() {
  if (secondRequestId) {
    // Cancel the animation
    window.cancelAnimationFrame(secondRequestId);

    // Reset the secondRequestId for the next animation.
    secondRequestId = undefined;
  }
}

// Pause on hover/focus
secondMarqueeSlider.addEventListener("mouseenter", () => secondPause());

// Unpause on mouse out / defocus
secondMarqueeSlider.addEventListener("mouseleave", () => secondPlay());





